export default __webpack_public_path__ + "860de3def79240184394d24d30cebd4b.png";